import framericonsAppleTouchIcon from '#app/assets/framericons/apple-touch-icon.png?url'
import framericonsFaviconIco from '#app/assets/framericons/favicon.ico?url'
import framericonsFavicon from '#app/assets/framericons/favicon.svg?url'
import framericonsOgImage from '#app/assets/framericons/og-image.png?url'
import notioniconsAppleTouchIcon from '#app/assets/notionicons/apple-touch-icon.png?url'
import notioniconsFaviconIco from '#app/assets/notionicons/favicon.ico?url'
import notioniconsFavicon from '#app/assets/notionicons/favicon.svg?url'
import notioniconsOgImage from '#app/assets/notionicons/og-image.png?url'

export interface DomainAssets {
	favicon: string
	faviconIco: string
	appleTouchIcon: string
	ogImage: string
}

export type DomainKey = 'notionicons' | 'framericons' | 'iconited'

// Asset configurations for each domain
export const DOMAIN_ASSETS: Record<DomainKey, DomainAssets> = {
	notionicons: {
		favicon: notioniconsFavicon,
		faviconIco: notioniconsFaviconIco,
		appleTouchIcon: notioniconsAppleTouchIcon,
		ogImage: notioniconsOgImage,
	},
	framericons: {
		favicon: framericonsFavicon,
		faviconIco: framericonsFaviconIco,
		appleTouchIcon: framericonsAppleTouchIcon,
		ogImage: framericonsOgImage,
	},
	iconited: {
		favicon: framericonsFavicon,
		faviconIco: framericonsFaviconIco,
		appleTouchIcon: framericonsAppleTouchIcon,
		ogImage: '',
	},
}
